import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { DV360_FLOODLIGHT_CONFIG_ID, shouldLoadDv360Floodlight } from "@/lib/dv360Floodlight";
import { useTagLoaderReady } from "./useTagLoaderReady";

/**
 * Global gtag.js snippet for DC-16638578 (required for Floodlight activity tags).
 */
export function Dv360FloodlightGlobal() {
  const $ = _c(5);
  const loadTags = useTagLoaderReady();
  if (!shouldLoadDv360Floodlight()) {
    return null;
  }
  let t0;
  if ($[0] !== loadTags) {
    t0 = loadTags && <Script src={`https://www.googletagmanager.com/gtag/js?id=${DV360_FLOODLIGHT_CONFIG_ID}`} strategy="afterInteractive" />;
    $[0] = loadTags;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Script id="dv360-floodlight-gtag-init" strategy="afterInteractive">{`
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${DV360_FLOODLIGHT_CONFIG_ID}', { 'conversion_linker': false });
`}</Script>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <>{t0}{t1}</>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}